import { styled } from '@mui/material';
import React from 'react';

// A reusable scroll container with consistent scrollbar styling and inner padding
const Root = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  paddingTop: '8px',
  paddingBottom: '8px',
  paddingRight: '6px',
  boxSizing: 'border-box',
  overflowY: 'scroll',
  overflowX: 'hidden',
  scrollbarGutter: 'stable',
  // Firefox
  scrollbarWidth: 'thin',
  scrollbarColor: '#A9B6BC #E3E7E8',
  // WebKit
  '::-webkit-scrollbar': {
    width: '12px',
  },
  '::-webkit-scrollbar-track': {
    background: '#E3E7E8',
    borderRadius: '6px',
    boxShadow: 'inset 0 0 0 1px #B9C6CD',
  },
  '::-webkit-scrollbar-thumb': {
    background: '#A9B6BC',
    borderRadius: '6px',
    border: '2px solid #E3E7E8',
    borderRightWidth: '6px',
  },
  '::-webkit-scrollbar-thumb:hover': {
    background: '#8FA0A8',
  },
  // Create top spacing using the (usually hidden) scrollbar button area
  '::-webkit-scrollbar-button:single-button:vertical:decrement': {
    height: '8px',
    background: 'transparent',
    border: 'none',
  },
}));

const ScrollBox = ({ children, sx, ...props }) => {
  return (
    <Root sx={sx} {...props}>
      {children}
    </Root>
  );
};

export default ScrollBox;
